import Amplify from 'aws-amplify';

const Auth = Amplify.Auth;

export default class AuthService {

  static getCurrentUser() {
    const userPool = AuthService.getUserPool()
    return userPool.getCurrentUser()
  }

  static prepareAuth(authConfig) {
    Auth.configure(authConfig)
  }

  static getCurrentUserAsync() {
    return Auth.currentAuthenticatedUser()
  }

  static getCurrentSessionAsync() {
    return Auth.currentCredentials()
  }

  static getUserAttributesAsync(cognitoUser) {
    return new Promise((resolve, reject) => {
      cognitoUser.getUserAttributes((err, attributes) => {
        if (err) {
          return reject(err)
        }

        const attrs = {}
        attributes.forEach(attr => {
          attrs[attr.getName()] = attr.getValue()
        })

        return resolve(attrs)
      })
    })
  }

  static getCredentials() {
    return Auth.currentCredentials()
  }

  static signIn() {
    Auth.federatedSignIn({ 'provider': 'azure-ad' })
  }

  static isValidSession() {
    return Auth.currentCredentials()
  }

  static logoutUser() {
    return Auth.signOut()
  }
}



// WEBPACK FOOTER //
// ./client/services/auth.js